import { ChangeEvent, FormEvent, useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import apagarImg from '../../assets/img/excluir.png'
import taskImg from '../../assets/img/tarefas.png'
import { ModalEstadoContext } from '../../contexts/ModalEstado'
import { converterNumero, criptografarDado, descriptografarDado, moedaMascara } from '../../helpers'
import { assinaturasItensLocais, assinaturasItensResposta, paramsAssinaturasLista } from '../../interfaces/assinaturas'
import { cadastrosRespostaPayload } from '../../interfaces/cadastros'
import { listaCategoriasResposta } from '../../interfaces/categorias'
import { listaCentrosRespostaPayload } from '../../interfaces/centros'
import { atualizarAssinatura, atualizarItemAssinatura, cadastrarAssinatura, cadastrarItemAssinatura } from '../../services/assinaturas'
import { listarCadastros } from '../../services/cadastros'
import { lisatarCategorias } from '../../services/categorias'
import { lisatarCentros } from '../../services/centros'
import DivSituacao from '../DivSituacao'
import ModalItensAssinaturas from '../ModalItensAssinaturas'
import { Button, Loader } from '../Styles'
import Permissoes from '../../middleware/Permissoes'

function ModalAssinaturas({ assinatura }: paramsAssinaturasLista) {

    const location = useLocation()

    const { modalExibir, modalSecundarioExibir, modalSecundario, atualizarDados } = useContext(ModalEstadoContext)

    const { search } = location
    const params = new URLSearchParams(search)
    const tipo = params.get('tipo')

    const [cadastro, setCadastro] = useState(assinatura?.cadastro.id)
    const [cadastros, setCadastros] = useState<cadastrosRespostaPayload[]>([])
    const [valorTotal, setValorTotal] = useState(assinatura?.valorTotal || 0)
    const [descricao, setDescricao] = useState(assinatura?.descricao || "")
    const [cobrancaAutomatica, setCobrancaAutomatica] = useState(assinatura?.cobrancaAutomatica || false)
    const [recorrencia, setRecorrencia] = useState<string>(assinatura?.recorrencia || "")
    const [recorrenciaDia, setRecorrenciaDia] = useState<number | null>(assinatura?.recorrenciaDia || null)
    const [recorrenciaMes, setRecorrenciaMes] = useState<number | null>(assinatura?.recorrenciaMes || null)
    const [formaCobranca, setFormaCobranca] = useState(assinatura?.formaCobranca || "")
    const [inicioCobranca, setInicioCobranca] = useState(assinatura?.inicioCobranca)
    const [processando, setProcessando] = useState(false)
    const [assinaturaItensLocais, setAssinaturaItensLocais] = useState<assinaturasItensLocais[]>([])
    const [servicoLocal, setServicoLocal] = useState<assinaturasItensLocais>({
        idCategoria: "",
        idCentro: "",
        descricao: "",
        valor: 0
    })
    const [categorias, setCategorias] = useState<listaCategoriasResposta[]>([]);
    const [centros, setCentros] = useState<listaCentrosRespostaPayload[]>([]);
    const [situacao, setSituacao] = useState(assinatura?.situacao || "");
    const [itemAssinaturaSelecionado, setItemAssinaturaSelecionado] = useState<assinaturasItensResposta>();

    function adicionarServicosLocais(e: FormEvent) {

        e.preventDefault()

        if (servicoLocal.descricao === "" || servicoLocal.valor === 0) return toast.warn('Preencha os campos de Serviços')

        setAssinaturaItensLocais([...assinaturaItensLocais, servicoLocal])
        setServicoLocal({
            idCategoria: "",
            idCentro: "",
            descricao: "",
            valor: 0
        })

        return
    }

    const adicionarServico = async () => {
        try {
            const permissoesArray = JSON.parse(descriptografarDado(localStorage.getItem('permissao') ?? ""))
            const permissoesAutorizadas = ['master', 'administrativo', 'financeiro_assinatura_atualizar', 'financeiro_despesa_recorrente_atualizar']
            const temPermissao = permissoesArray.some((permissao: string) => permissoesAutorizadas.includes(permissao))

            if(!temPermissao) return toast.warn("Você não tem permissão para adicionar novos serviços na assinatura.")
            if (!assinatura) return toast.warn("Assinatura não encontrada.")

            const resposta = await cadastrarItemAssinatura({ ...servicoLocal, valor: Number(converterNumero(servicoLocal.valor)) / 100, idAssinatura: criptografarDado(assinatura.id.toString()) })

            if (resposta.status === 201) {
                atualizarDados()
                toast.success('Assinatura Cadastrada com Sucesso')
                setServicoLocal({
                    idCategoria: "",
                    idCentro: "",
                    descricao: "",
                    valor: 0
                })

                return
            }

        } catch (error: any) {

            if (error.status === 409) {
                toast.warn("A Assinatura precisa estar Ativa para Cadastrar um Serviço")
                return
            }
            toast.error('Falha ao Cadastrar um Item na Assinatura')
            return
        } finally {
            setProcessando(false)
        }
    }

    const excluirServicos = (posicao: number) => {
        setAssinaturaItensLocais(items => [...items])

        return assinaturaItensLocais.splice(posicao, 1)
    }

    const dataMinimaCobranca = () => {

        const hoje = new Date();

        const ano = hoje.getFullYear()
        const mes = hoje.getMonth() + 1
        const dia = hoje.getDate()

        const dataMinima = `${ano}-${mes.toString().padStart(2, '0')}-${dia.toString().padStart(2, '0')}`

        return dataMinima
    }

    const createAssinatura = async (e: FormEvent) => {
        e.preventDefault()
        const permissoesArray = JSON.parse(descriptografarDado(localStorage.getItem('permissao') ?? ""))
        const permissoesAutorizadas = ['master', 'administrativo', 'financeiro_assinatura_cadastrar', 'financeiro_despesa_recorrente_cadastrar']
        const temPermissao = permissoesArray.some((permissao: string) => permissoesAutorizadas.includes(permissao))

        if(!temPermissao) return toast.warn("Você não tem permissão para adicionar novas assinaturas.")
        setProcessando(true)

        try {
            if (assinaturaItensLocais.length === 0) {
                return toast.warn("Adicione um serviço para salvar a assinatura.")
            }

            if (!cadastro || !descricao || !valorTotal || !tipo) {
                return toast.warn("Dados incompletos.")
            }

            const assinaturaItensConvertidos = assinaturaItensLocais.map((item) => ({
                ...item,
                valor: Number(converterNumero(item.valor)) / 100,
            }));

            const payload = {
                idCadastro: cadastro,
                tipo,
                descricao,
                valorTotal: valorTotal / 100,
                inicioCobranca,
                formaCobranca,
                cobrancaAutomatica,
                recorrencia,
                recorrenciaDia,
                recorrenciaMes,
                assinaturaItens: assinaturaItensConvertidos
            }

            const resposta = await cadastrarAssinatura(payload)

            if (resposta.status === 201) {
                atualizarDados()
                modalExibir("")
                toast.success('Assinatura Cadastrada com Sucesso')
                return
            }

        } catch {
            toast.error('Falha ao Cadastrar uma Assinatura')
            return
        } finally {
            setProcessando(false)
        }
    }

    const updateAssinatura = async (e: FormEvent) => {
        e.preventDefault()
        const permissoesArray = JSON.parse(descriptografarDado(localStorage.getItem('permissao') ?? ""))
        const permissoesAutorizadas = ['master', 'administrativo', 'financeiro_assinatura_atualizar', 'financeiro_despesa_recorrente_atualizar']
        const temPermissao = permissoesArray.some((permissao: string) => permissoesAutorizadas.includes(permissao))

        if(!temPermissao) return toast.warn("Você não tem permissão para atualizar os dados da assinatura.")
        setProcessando(true)

        if (!assinatura) {
            return toast.warn("Assinatura não encontrada.")
        }

        const idAssinaturaCript = criptografarDado(assinatura.id.toString())

        const payload = {
            descricao,
            tipo,
            formaCobranca,
            cobrancaAutomatica,
            recorrencia,
            recorrenciaDia,
            recorrenciaMes,
            inicioCobranca,
            situacao,
        }

        try {

            const resposta = await atualizarAssinatura(idAssinaturaCript, payload)

            if (resposta.status === 200) {
                setProcessando(false)
                toast.success('Dados Atualizados com Sucesso')
                atualizarDados()
                return
            }

        } catch {
            setProcessando(false)
            toast.error('Falha ao Atualizar a Assinatura')

            return
        }
    }

    const atualizarSituacaoAssinatura = async (item: assinaturasItensResposta) => {
        const permissoesArray = JSON.parse(descriptografarDado(localStorage.getItem('permissao') ?? ""))
        const permissoesAutorizadas = ['master', 'administrativo', 'financeiro_assinatura_atualizar', 'financeiro_despesa_recorrente_atualizar']
        const temPermissao = permissoesArray.some((permissao: string) => permissoesAutorizadas.includes(permissao))

        if(!temPermissao) return toast.warn("Você não tem permissão para atualizar a situação da assinatura.")
        setProcessando(true)

        if (!item) {
            toast.error("Item da Assinatura não encontrado.")
            return setProcessando(false)
        }

        const idItemServicoCript = criptografarDado(item.id.toString())
        try {
            if (!assinatura) return toast.warn("Assinatura não encontrada.")

            const payload = {
                situacao: item.situacao === "Ativo" ? "Inativo" : "Ativo",
                idAssinatura: criptografarDado(assinatura.id.toString())
            }

            const resposta = await atualizarItemAssinatura(idItemServicoCript, payload)

            if (resposta.status === 200) {
                setProcessando(false)
                toast.success('Situação do Serviço Atualizada com Sucesso')
                atualizarDados()
                return
            }

        } catch (error: any) {
            if (error.status === 409) {
                toast.warn(`${tipo === 'receita' ? 'A Assinatura precisa de pelo menos um Serviço Ativo.' : 'A Recorrência precisa ter pelo menos uma despesa vinculada'}`)
                return
            }

            toast.error('Falha ao Atualizar Situação do Serviço')
            return
        } finally {
            setProcessando(false)
        }
    }

    const aplicarMascaraValorServico = (e: ChangeEvent<HTMLInputElement>) => {

        return setServicoLocal({ ...servicoLocal, valor: moedaMascara(e.target.value) })
    }

    const abrirModalAtualizarItem = (item: assinaturasItensResposta) => {
        setItemAssinaturaSelecionado(item)
        modalSecundarioExibir("ModalItensAssinaturas")
    }

    useEffect(() => {
        const buscarDadosIniciais = async () => {
            setProcessando(true)

            try {
                const [resCadastros, resCategorias, resCentros] = await Promise.all([
                    listarCadastros({ tipo: '', termo: '', pagina: 1, situacao: '' }),
                    lisatarCategorias({ descricao: '', situacao: 'ativa' }),
                    lisatarCentros({ descricao: '', situacao: 'ativo' })
                ])

                if (resCadastros.status === 200) {
                    setCadastros(resCadastros.data)
                }

                if (resCategorias.status === 200) {
                    setCategorias(resCategorias.data)
                }

                if (resCentros.status === 200) {
                    setCentros(resCentros.data)
                }

            } catch (error) {
                toast.error("Erro ao carregar os dados iniciais.")
            } finally {
                setProcessando(false)
            }
        }

        buscarDadosIniciais()
    }, [])

    useEffect(() => {
        const valorBaseAssinatura = assinatura?.valorTotal ? Number(assinatura.valorTotal * 100) : 0;

        const totalServicosLocais = assinaturaItensLocais.reduce((acc, servico) => {
            const valor = converterNumero(servico.valor) || 0;
            return acc + valor;
        }, 0);

        const totalGeral = valorBaseAssinatura + totalServicosLocais;
        setValorTotal(totalGeral);
    }, [assinaturaItensLocais, assinatura]);

    return (
        <div id='fundoModal'>
            {modalSecundario.nome === "ModalItensAssinaturas" && itemAssinaturaSelecionado && <ModalItensAssinaturas itemAssinatura={itemAssinaturaSelecionado} />}
            <section id='containerModalNovo'>
                <span id='novoContainerTitulo'>
                    <img id='adicionarModalIcone' src={taskImg} alt='' />
                    <p>{!assinatura ? tipo === "despesa" ? "Nova Recorrência" : 'Nova Assinatura' : tipo === "despesa" ? "Visualizar Recorrência" : 'Vizualizar Assinatura'}</p>
                </span>
                <form id='formModalNovo' onSubmit={assinatura ? updateAssinatura : createAssinatura}>
                    <section>
                        <span>
                            <label htmlFor="valorTotal">Valor Total</label>
                            <input
                                id='valorTotal'
                                value={(valorTotal  / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                disabled
                                type='text' />
                        </span>
                        <Permissoes permissoes={['master', 'administrativo']}>
                            <>
                                {assinatura &&
                                    <span>
                                        <label htmlFor="valorTotal">Situação</label>
                                        <select value={situacao} onChange={(e) => setSituacao(e.target.value)} required>
                                            <option value="" disabled selected>Selecione uma Opção</option>
                                            <option value='Ativa'>Ativa</option>
                                            <option value='Pausada'>Pausada</option>
                                            <option value='Cancelada'>Cancelada</option>
                                        </select>
                                    </span>
                                }
                            </>
                        </Permissoes>
                    </section>
                    <section>
                        <span>
                            <label htmlFor="clienteLancamento">{tipo === 'receita' ? 'Cliente' : 'Fornecedor/Colaborador'}</label>
                            <select id='clienteLancamento' value={cadastro} onChange={(e) => setCadastro(Number(e.target.value))} required disabled={assinatura ? true : false}>
                                <option value='' selected disabled>{tipo === "despesa" ? "Selecione o Fornecedor/Colaborador" : "Selecione o Cliente"}</option>
                                {tipo === 'receita' ? cadastros.filter(cadastro => cadastro.tipo === 'cliente').map((cadastro) => (
                                    <option key={cadastro.id} value={cadastro.id}>{cadastro.nomeFantasia}</option>
                                )) : cadastros.filter((cadastro) => ['colaborador', 'fornecedor'].includes(cadastro.tipo)).map((cadastro) => (
                                    <option key={cadastro.id} value={cadastro.id}>{cadastro.nomeFantasia}</option>))}
                            </select>
                        </span>
                    </section>
                    <section>
                        <span>
                            <label htmlFor="descricaoLancamento">Descrição</label>
                            <input
                                id='descricaoLancamento'
                                value={descricao === undefined ? '' : descricao}
                                onChange={(e) => setDescricao(e.target.value)}
                                placeholder='Descrição'
                                type='text'
                                required />
                        </span>
                    </section>
                    <section>
                        <span>
                            <label htmlFor="contaTransacao">Forma de Recebimento</label>
                            <select value={formaCobranca} onChange={(e) => setFormaCobranca(e.target.value)} required>
                                <option value="" disabled selected>Selecione uma Opção</option>
                                <option value='Dinheiro'>Dinheiro</option>
                                <option value='Boleto'>Boleto</option>
                                <option value='Pix'>Pix</option>
                                <option value='Transferência Bancária'>Transferência Bancária</option>
                                <option value='Cartão de Crédito'>Cartão de Crédito</option>
                                <option value='Cartão de Débito'>Cartão de Débito</option>
                                <option value='Outros'>Outros</option>
                            </select>
                        </span>
                        <span>
                            <label htmlFor="competencia">Início Cobrança</label>
                            <input
                                id="competencia"
                                type='date'
                                value={inicioCobranca || ""}
                                onChange={(e) => setInicioCobranca(e.target.value)}
                                min={!assinatura ? dataMinimaCobranca() : undefined}
                                required />
                        </span>
                    </section>
                    <section className='automacaoTarefas'>
                        <span>
                            <label htmlFor="">Frequência</label>
                            <select value={recorrencia || ''} onChange={(e) => setRecorrencia(e.target.value)} required>
                                <option value="">Selecione a Frequência</option>
                                <option value="mensal">Mensal</option>
                                <option value="anual">Anual</option>
                            </select>
                        </span>
                        {recorrencia === 'anual' && (<span>
                            <label htmlFor="inicioAutomacao">Recorrência Mês</label>
                            <select value={recorrenciaMes || ''} onChange={(e) => setRecorrenciaMes(Number(e.target.value))} required>
                                <option value="" >Selecione o Mês</option>
                                <option value="0">Janeiro</option>
                                <option value="1">Fevereiro</option>
                                <option value="2">Março</option>
                                <option value="3">Abril</option>
                                <option value="4">Maio</option>
                                <option value="5">Junho</option>
                                <option value="6">Julho</option>
                                <option value="7">Agosto</option>
                                <option value="8">Setembro</option>
                                <option value="9">Outubro</option>
                                <option value="10">Novembro</option>
                                <option value="11">Dezembro</option>
                            </select>
                        </span>)}
                        {(recorrencia === 'semanal') && <span>
                            <label htmlFor="">Dia da Semana</label>
                            <select value={recorrenciaDia || ''} onChange={(e) => setRecorrenciaDia(Number(e.target.value))} required>
                                <option value="">Selecione o Dia</option>
                                <option value="0">Domingo</option>
                                <option value="1">Segunda</option>
                                <option value="2">Terça</option>
                                <option value="3">Quarta</option>
                                <option value="4">Quinta</option>
                                <option value="5">Sexta</option>
                                <option value="6">Sábado</option>
                            </select>
                        </span>}
                        {(recorrencia === 'mensal' || recorrencia === 'anual') && <span>
                            <label htmlFor="inicioAutomacao">Recorrência Dia</label>
                            <input
                                type="number"
                                min="1"
                                max="31"
                                value={recorrenciaDia ?? ""}
                                onChange={(e) => setRecorrenciaDia(Number(e.target.value))}
                                placeholder="Dia do mês"
                            />
                        </span>}
                    </section>
                    <div className='contentCobrancaAutomatica'>
                        <div className='tarefasRecorrentes'>
                            <input
                                checked={!!cobrancaAutomatica}
                                className='toggleCobrancaAutomatica'
                                id='toggleCobrancaAutomatica'
                                type="checkbox"
                                onChange={() => setCobrancaAutomatica(!cobrancaAutomatica)} />
                            <label id='toggleCobrancaAutomatica' htmlFor='toggleCobrancaAutomatica'></label>
                            <p>Cobrança Automatica</p>
                        </div>

                        <Button type='button' cor='salvar' isLoading={processando} onClick={assinatura ? adicionarServico : adicionarServicosLocais}>
                            {!processando && 'Adicionar Serviço'}
                            {processando && <Loader isLoading={processando} />}
                        </Button>
                    </div>

                    <form id='formModalNovo'>
                        <section>
                            <span>
                                <label>Descrição</label>
                                <input
                                    value={servicoLocal.descricao}
                                    onChange={(e) => setServicoLocal({ ...servicoLocal, descricao: e.target.value })}
                                    placeholder='Descrição'
                                    type="text"
                                    required
                                />
                            </span>
                            <span>
                                <label>Valor</label>
                                <input
                                    value={moedaMascara(servicoLocal.valor)}
                                    onChange={(e) => aplicarMascaraValorServico(e)}
                                    placeholder='R$ 0,00'
                                    type="text"
                                />
                            </span>
                            <span>
                                <label>Categoria</label>
                                <select value={servicoLocal.idCategoria || ""} onChange={(e) => setServicoLocal({ ...servicoLocal, idCategoria: e.target.value })} required>
                                    <option value='' selected>Selecione uma Categoria</option>
                                    {categorias.filter(categoria => categoria.tipo === tipo).map((categoria) => (
                                        <option key={categoria.id} value={categoria.id}>{categoria.descricao}</option>
                                    ))}
                                </select>
                            </span>
                            <span>
                                <label>Centro de Resultado</label>
                                <select value={servicoLocal.idCentro || ""} onChange={(e) => setServicoLocal({ ...servicoLocal, idCentro: e.target.value })} required>
                                    <option value='' selected>Selecione uma Opção</option>
                                    {centros.filter((centro) => ["Centro de Resultado"].includes(centro.tipo)).map((centro) => (
                                        <option key={centro.id} value={centro.id}>{centro.descricao}</option>
                                    ))}
                                </select>
                            </span>
                        </section>
                        <details open>
                            <summary style={{ marginTop: 10 }}>
                                <label> {tipo === "despesa" ? "Rateio" : "Serviços"}</label>
                            </summary>
                            <span>
                                {assinaturaItensLocais.length > 0 && assinaturaItensLocais.map((servico, index) => (
                                    <div className='listaAssinantes' key={index}>
                                        <p style={{ minWidth: 250 }}>{servico.descricao}</p>
                                        <p style={{ minWidth: 150 }}>Valor: <strong>{servico.valor}</strong></p>
                                        <select value={servico.idCategoria} onChange={(e) => setAssinaturaItensLocais(prev => prev.map((item, i) => i === index ? { ...item, idCategoria: e.target.value } : item))} required>
                                            {categorias.filter(categoria => categoria.tipo === tipo).map((categoria) => (
                                                <option key={categoria.id} value={categoria.id}>{categoria.descricao}</option>
                                            ))}
                                        </select>
                                        <select value={servico.idCentro} onChange={(e) => setAssinaturaItensLocais(prev => prev.map((item, i) => i === index ? { ...item, idCentro: e.target.value } : item))} required>
                                            {centros.filter((centro) => ["Centro de Resultado"].includes(centro.tipo)).map((centro) => (
                                                <option key={centro.id} value={centro.id}>{centro.descricao}</option>
                                            ))}
                                        </select>
                                        <img className='iconeExcluirUsuario' src={apagarImg} alt="" title='Excluir Assinante' onClick={() => excluirServicos(index)}></img>
                                    </div>
                                ))
                                }
                                {assinatura?.assinaturasItens && assinatura?.assinaturasItens.length > 0 && assinatura?.assinaturasItens.map((item, index) => (
                                    <div className='listaAssinantes' key={index}>
                                        <p style={{ minWidth: 250 }} onClick={() => abrirModalAtualizarItem(item)}>{item.descricao}</p>
                                        <p style={{ minWidth: 150 }} onClick={() => abrirModalAtualizarItem(item)}>Valor: <strong>{moedaMascara(item.valor)}</strong></p>
                                        <p onClick={() => abrirModalAtualizarItem(item)}><DivSituacao texto={item.situacao} cor={item.situacao.toLowerCase()} /></p>
                                        <input
                                            checked={item.situacao === "Ativo"}
                                            className='toggleCobrancaAutomatica'
                                            id={`toggleSituacaoServico-${item.id}`}
                                            type="checkbox"
                                            onChange={() => atualizarSituacaoAssinatura(item)} />
                                        <label id='toggleCobrancaAutomatica' htmlFor={`toggleSituacaoServico-${item.id}`}></label>
                                    </div>
                                ))}
                            </span>
                        </details>
                        <details>
                            <summary style={{ marginTop: 10 }}>
                                <label>Ocorrências</label>
                            </summary>
                            <span>
                                {assinatura?.lancamentos && assinatura?.lancamentos.length > 0 && assinatura?.lancamentos.map((lancamento, index) => (
                                    <div className='listaAssinantes' key={index}>
                                        <p style={{ minWidth: 250 }}>{lancamento.descricao}</p>
                                        <p style={{ minWidth: 150 }}>Valor: <strong>{moedaMascara(lancamento.valorTotal)}</strong></p>
                                        <p style={{ minWidth: 230, textAlign: "center" }}><DivSituacao texto={lancamento.situacao} cor={lancamento.situacao.toLowerCase().replaceAll(' ', '')} /></p>
                                    </div>
                                ))}
                            </span>
                        </details>
                    </form>
                    <span id="botoesContainer">
                        <Button type='button' cor='cancelar' isLoading={processando} onClick={() => modalExibir("")}>Cancelar</Button>
                        <Button type='submit' cor='salvar' isLoading={processando} disabled={processando}>
                            {!processando && 'Salvar Dados'}
                            {processando && <Loader isLoading={processando} />}
                        </Button>
                    </span>
                </form>
            </section>
        </div>
    )
}

export default ModalAssinaturas
